import React from 'react';
import { styled, Icon } from '@teko/ui';
import { Tag } from '@teko/ds-foundation';
import { isFloat } from '@teko/utils';
import { Text } from '../Text/Text.es.js';
import { ProductPrice } from '../ProductPrice/ProductPrice.es.js';
import { ListItem } from '../ListItem/ListItem.es.js';
import { MobileLink } from '../MobileLink/MobileLink.es.js';
import { OrderImage } from '../OrderImage/OrderImage.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const StyledSku = styled(Text)`
  margin-bottom: 8px;
`;
const PromotionLine = styled.div`
  margin-top: 4px;
  margin-bottom: 4px;
  display: flex;
  align-items: baseline;
`;
const StyledSpan = styled.span`
  color: #848788;
  margin-left: 5px;
`;
const GiftsWrapper = styled.div`
  background: #f8f8fc;
  margin-top: -10px;
  padding: 8px 16px;
  margin: 0 16px 16px 16px;
  border-radius: 8px;
`;
const GiftName = styled.div`
  font-size: 14px;
  margin-left: 5px;
  line-height: 20px;
  flex: 1 1;
  align-items: center;
`;
const StyledProductPrice = styled(ProductPrice)(({ theme }) => `
    .product-price {
      &__price {
        font-size: 0.875rem;
        font-weight: 500;
        color: ${theme == null ? void 0 : theme.colors.text};
      }

      &__listed-price {
        color: ${theme == null ? void 0 : theme.colors.gray130};
        font-size: 0.75rem;
        font-weight: 400;
      }
    }
  `);
const StyledListItem = styled(ListItem)`
  background: inherit;
`;
const OrderProductLine = ({
  product,
  showGiftQty = true,
  productOnClick
}) => {
  const {
    imageUrl,
    sku,
    productTag,
    name,
    price,
    unitAdd,
    link,
    prizes,
    quantity,
    clearanceTypeTag
  } = product;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MobileLink, __spreadProps(__spreadValues({}, productOnClick ? null : link), {
    href: productOnClick && (link == null ? void 0 : link.href) ? link.href : ""
  }), /* @__PURE__ */ React.createElement("div", {
    onClick: () => productOnClick == null ? void 0 : productOnClick(product)
  }, /* @__PURE__ */ React.createElement(StyledListItem, {
    left: /* @__PURE__ */ React.createElement(OrderImage, {
      images: [imageUrl || ""],
      width: "84px"
    }),
    title: /* @__PURE__ */ React.createElement(Text, {
      fontSize: 14,
      fontWeight: "400",
      maxLines: 2,
      marginBottom: "5px"
    }, productTag && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tag, {
      type: "primary",
      variant: "branding",
      content: productTag
    }), "\xA0"), clearanceTypeTag && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tag, {
      type: "secondary",
      variant: "branding",
      content: clearanceTypeTag
    }), "\xA0"), name),
    subTitle: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(StyledSku, {
      fontSize: 12,
      color: "#848788"
    }, "SKU: ", sku || "")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(StyledProductPrice, {
      price: price || 0,
      consultationServiceFee: unitAdd || 0
    }))),
    right: /* @__PURE__ */ React.createElement(Text, {
      fontSize: 12,
      color: "#848788"
    }, "X", isFloat(quantity || 0) ? quantity == null ? void 0 : quantity.toFixed(4).replace(".", ",") : quantity == null ? void 0 : quantity.toLocaleString("vi-VN"))
  }), !!(prizes == null ? void 0 : prizes.length) && /* @__PURE__ */ React.createElement(GiftsWrapper, null, prizes.map((gift) => /* @__PURE__ */ React.createElement(PromotionLine, {
    key: gift.name
  }, /* @__PURE__ */ React.createElement(Icon, {
    name: "gift",
    size: 14
  }), /* @__PURE__ */ React.createElement(GiftName, null, showGiftQty && /* @__PURE__ */ React.createElement(StyledSpan, null, `${gift.quantity.toLocaleString("vi-VN")}x`), ` ${gift.name}`)))))));
};

export { GiftName, OrderProductLine, StyledProductPrice, StyledSpan };
